export const View = () => import("./View.vue");
export const Create = () => import("./Create.vue");
export const Receive = () => import("./Receive.vue");
export const BankTransfer = () => import("./BankTransfer.vue");
